module.exports = __webpack_public_path__ + "static/media/spinner.3e531847.svg";